import React from 'react'
import { Routes } from 'shared'
import styles from './tos_info.module.css'
import { I18nHtml } from '../i18n_html'

export const TOSInfo = () => {
  return (
    <I18nHtml
      as="p"
      className={styles.tosInfo}
      i18nKey="misc.tos_info"
      options={{
        tosUrl: Routes.termsGeneralPath(),
        additionalTosUrl: Routes.termsAdditionalPath(),
      }}
    />
  )
}
